

<template>
    <div>
		<a-modal
		:width='"55rem"'
		id='main-handhomes'
		title='title'
		v-model='visible'
		@on='handleOk'
		@cancel='handleCancel'
		:footer="null" 
		:dialog-style="{ top: '6vh'}"
		:keyboard='false'
		:maskClosable='false'>
			<div class='main-hand-title'>
				<div style="position: relative;top: .44rem;">{{fundFlag == 1?'債券添加':'債券審核'}}</div>
			</div>
            <div style="display: flex;">
				<!-- :"gland"'-->
				<div class="wland" >債券信息</div>
			</div>
			<div id='tubody-mainsk1'>
                <div id='handitemedit1'>
                    <div class="tabelMoreFzView main-mybody">
                        <div class="tabelMoreFzViewIn">
                            <!-- 1 -->
                            <div class="table_flex table_bottom">
                                <div class="table_flex table_flex_left">
                                    <div class="table_div_left">產品編號：</div>
                                    <div style="width: 100%;">
                                        <a-input :class="{'border_red': obj.falg3}" @input="obj.falg3=false" :disabled='!bondEditor' v-model="form.bond_code"></a-input>
                                    </div>
                                </div>
                                <div style="width: 5%;flex-shrink: 0;"></div>
                                <div class="table_flex">
                                    <div class="table_div_right">Product Code：</div>
                                    <div style="width: 100%;">
                                        <a-input :class="{'border_red': obj.falg3}" @input="obj.falg3=false" :disabled='!bondEditor' v-model="form.bond_code"></a-input>
                                    </div>
                                </div>
                            </div>
                            <!-- 2 -->
                            <div class="table_flex table_bottom">
                                <div class="table_flex table_flex_left">
                                    <div class="table_div_left">產品名稱：</div>
                                    <div style="width: 100%;">
                                        <a-input :disabled='!bondEditor' :class="{'border_red': obj.falg1}" @input="obj.falg1=false"  v-model="form.bond_name_cn"></a-input>
                                    </div>
                                </div>
                                <div style="width: 5%;flex-shrink: 0;"></div>
                                <div class="table_flex">
                                    <div class="table_div_right">Product Name：</div>
                                    <div style="width: 100%;">
                                        <a-input :disabled='!bondEditor' :class="{'border_red': obj.falg2}" @input="obj.falg2=false,handleInput()" v-model="form.bond_name_en"></a-input>
                                    </div>
                                </div>
                            </div>
                            <!-- 3 -->
                            <div class="table_flex table_bottom">
                                <div class="table_flex table_flex_left">
                                    <div class="table_div_left">貨幣：</div>
                                    <div style="width: 100%;">
                                        <!-- <a-input :disabled='!bondEditor' v-model="form.three_month_returns_cn"></a-input> -->
                                        <a-select v-model="form.currency" :class="{'border_red': obj.falg10}" @change="obj.falg10=false" :disabled='!bondEditor'  style="width: 100%;">
                                            <a-select-option v-for="(item,index) in currencyList" :key="index" :value="parseInt(item.value)">{{item.text_cn}}</a-select-option>
                                        </a-select>
                                    </div>
                                </div>
                                <div style="width: 5%;flex-shrink: 0;"></div>
                                <div class="table_flex">
                                    <div class="table_div_right">Currency：</div>
                                    <div style="width: 100%;">
                                        <!-- <a-input :disabled='!bondEditor' v-model="form.three_month_returns_en"></a-input> -->
                                        <a-select v-model="form.currency" :class="{'border_red': obj.falg10}" @change="obj.falg10=false" :disabled='!bondEditor'  style="width: 100%;">
                                            <a-select-option v-for="(item,index) in currencyList" :key="index" :value="parseInt(item.value)">{{item.text_en}}</a-select-option>
                                        </a-select>
                                    </div>
                                </div>
                            </div>
                            <!-- 4 -->
                            <div class="table_flex table_bottom">
                                <div class="table_flex table_flex_left">
                                    <div class="table_div_left">派息頻率：</div>
                                    <div style="width: 100%;">
                                        <!-- <a-input :disabled='!bondEditor' v-model="form.returns_2022_cn"></a-input> -->
                                        <a-select v-model="form.coupon_frequency" :class="{'border_red': obj.falg16}" @change="obj.falg16=false" :disabled='!bondEditor'  style="width: 100%;">
                                            <a-select-option v-for="(item,index) in factionalList" :key="index" :value="parseInt(item.value)">{{item.text_cn}}</a-select-option>
                                        </a-select>
                                    </div>
                                </div>
                                <div style="width: 5%;flex-shrink: 0;"></div>
                                <div class="table_flex">
                                    <div class="table_div_right">Coupon Frequency：</div>
                                    <div style="width: 100%;">
                                        <!-- <a-input :disabled='!bondEditor' v-model="form.returns_2022_en"></a-input> -->
                                        <a-select v-model="form.coupon_frequency" :class="{'border_red': obj.falg16}" @change="obj.falg16=false" :disabled='!bondEditor'  style="width: 100%;">
                                            <a-select-option v-for="(item,index) in factionalList" :key="index" :value="parseInt(item.value)">{{item.text_en}}</a-select-option>
                                        </a-select>
                                    </div>
                                </div>
                            </div>
                            <!-- 5 -->
                            <div class="table_flex table_bottom">
                                <div class="table_flex table_flex_left">
                                    <div class="table_div_left">年度票息：</div>
                                    <div style="width: 100%;">
                                        <a-input :disabled='!bondEditor' :class="{'border_red': obj.falg9}" @blur="blurClick(4)" @input="obj.falg9=false" v-model="form.coupon_rate" type="number" suffix="%" ></a-input>
                                    </div>
                                </div>
                                <div style="width: 5%;flex-shrink: 0;"></div>
                                <div class="table_flex">
                                    <div class="table_div_right">Coupon Rate：</div>
                                    <div style="width: 100%;">
                                        <a-input :disabled='!bondEditor' :class="{'border_red': obj.falg9}" @blur="blurClick(4)" @input="obj.falg9=false" v-model="form.coupon_rate" type="number" suffix="%" ></a-input>
                                    </div>
                                </div>
                            </div>
                            <!-- 6 -->
                            <div class="table_flex table_bottom">
                                <div class="table_flex table_flex_left">
                                    <div class="table_div_left">產品類別：</div>
                                    <div style="width: 100%;">
                                        <a-select v-model="form.bond_type" :class="{'border_red': obj.falg6}" @change="obj.falg6=false"  :disabled='!bondEditor'  style="width: 100%;">
                                            <a-select-option v-for="(item,index) in bondList" :key="index" :value="parseInt(item.value)">{{item.text_cn}}</a-select-option>
                                        </a-select>
                                    </div>
                                </div>
                                <div style="width: 5%;flex-shrink: 0;"></div>
                                <div class="table_flex">
                                    <div class="table_div_right">Product Type：</div>
                                    <div style="width: 100%;">
                                        <a-select v-model="form.bond_type" :class="{'border_red': obj.falg6}" @change="obj.falg6=false"  :disabled='!bondEditor'  style="width: 100%;">
                                            <a-select-option v-for="(item,index) in bondList" :key="index" :value="parseInt(item.value)">{{item.text_en}}</a-select-option>
                                        </a-select>
                                    </div>
                                </div>
                            </div>
                            <!-- 7 -->
                            <div class="table_flex table_bottom">
                                <div class="table_flex table_flex_left">
                                    <div class="table_div_left">到期日期：</div>
                                    <div style="width: 100%;">
                                        <a-date-picker :disabledDate="disabledDate" @change="formatDate(form.maturity_date,2),obj.falg18=false" :class="{'border_red': obj.falg18}" v-model="form.maturity_date" placeholder=" " :disabled='!bondEditor' />
                                        <!-- <a-input :disabled='!bondEditor' v-model="form.one_year_volatility_cn"></a-input> -->
                                    </div>
                                </div>
                                <div style="width: 5%;flex-shrink: 0;"></div>
                                <div class="table_flex">
                                    <div class="table_div_right">Maturity Date：</div>
                                    <div style="width: 100%;">
                                        <a-date-picker :disabledDate="disabledDate" @change="formatDate(form.maturity_date,2),obj.falg18=false" :class="{'border_red': obj.falg18}" v-model="form.maturity_date" placeholder=" " :disabled='!bondEditor' />
                                        <!-- <a-input :disabled='!bondEditor' v-model="form.one_year_volatility_en"></a-input> -->
                                    </div>
                                </div>
                            </div>
                              <!--8 -->
                              <div class="table_flex table_bottom">
                                <div class="table_flex table_flex_left">
                                    <div class="table_div_left">參考賣出價：</div>
                                    <div style="width: 100%;">
                                        <a-input :disabled='!bondEditor' :class="{'border_red': obj.falg19}"  @input="obj.falg19=false" @blur="blurClick(5)" @focus="focusClick(5)" @change="moneyClick(5)"  v-model="form.indicative_ask_price"></a-input>
                                    </div>
                                </div>
                                <div style="width: 5%;flex-shrink: 0;"></div>
                                <div class="table_flex">
                                    <div class="table_div_right">Indicative Ask Price：</div>
                                    <div style="width: 100%;">
                                        <a-input :disabled='!bondEditor' :class="{'border_red': obj.falg19}"  @input="obj.falg19=false" @blur="blurClick(5)" @focus="focusClick(5)" @change="moneyClick(5)"  v-model="form.indicative_ask_price"></a-input>
                                    </div>
                                </div>
                            </div>
                            <!-- 9 -->
                            <div class="table_flex table_bottom">
                                <div class="table_flex table_flex_left">
                                    <div class="table_div_left">參考買入價：</div>
                                    <div style="width: 100%;">
                                        <a-input :disabled='!bondEditor' :class="{'border_red': obj.falg20}"  @input="obj.falg20=false" @blur="blurClick(6)" @focus="focusClick(6)" @change="moneyClick(6)"  v-model="form.indicative_bid_price"></a-input>
                                    </div>
                                </div>
                                <div style="width: 5%;flex-shrink: 0;"></div>
                                <div class="table_flex">
                                    <div class="table_div_right">Indicative Bid Price：</div>
                                    <div style="width: 100%;">
                                        <a-input :disabled='!bondEditor' :class="{'border_red': obj.falg20}"  @input="obj.falg20=false" @blur="blurClick(6)" @focus="focusClick(6)" @change="moneyClick(6)"  v-model="form.indicative_bid_price"></a-input>
                                    </div>
                                </div>
                            </div>
                            <!-- 10 -->
                            <div class="table_flex table_bottom">
                                <div class="table_flex table_flex_left">
                                    <div class="table_div_left">入埸費：</div>
                                    <div style="width: 100%;">
                                        <a-input :disabled='!bondEditor' :class="{'border_red': obj.falg12}"  @input="obj.falg12=false" @blur="blurClick(3)" @focus="focusClick(3)" @change="moneyClick(3)"  v-model="form.minimum_amount"></a-input>
                                    </div>
                                </div>
                                <div style="width: 5%;flex-shrink: 0;"></div>
                                <div class="table_flex">
                                    <div class="table_div_right">Admission Amount：</div>
                                    <div style="width: 100%;">
                                        <a-input :disabled='!bondEditor' :class="{'border_red': obj.falg12}" @input="obj.falg12=false" @blur="blurClick(3)" @focus="focusClick(3)" @change="moneyClick(3)"  v-model="form.minimum_amount"></a-input>
                                    </div>
                                </div>
                            </div>
                            <!-- 11 -->
                            <div class="table_flex table_bottom">
                                <div class="table_flex table_flex_left">
                                    <div class="table_div_left">賣出到期收益率：</div>
                                    <div style="width: 100%;">
                                        <a-input :disabled='!bondEditor' :class="{'border_red': obj.falg21}" @blur="blurClick(7)" @input="obj.falg21=false" v-model="form.ask_yield_to_maturity" type="number" suffix="%" ></a-input>
                                    </div>
                                </div>
                                <div style="width: 5%;flex-shrink: 0;"></div>
                                <div class="table_flex">
                                    <div class="table_div_right">Ask Yield To Maturity：</div>
                                    <div style="width: 100%;">
                                        <a-input :disabled='!bondEditor' :class="{'border_red': obj.falg21}" @blur="blurClick(7)" @input="obj.falg21=false" v-model="form.ask_yield_to_maturity" type="number" suffix="%" ></a-input>
                                    </div>
                                </div>
                            </div>
                            <!-- 12 -->
                            <div class="table_flex table_bottom">
                                <div class="table_flex table_flex_left">
                                    <div class="table_div_left">買入到期收益率：</div>
                                    <div style="width: 100%;">
                                        <a-input :disabled='!bondEditor' :class="{'border_red': obj.falg22}" @blur="blurClick(8)" @input="obj.falg22=false" v-model="form.bid_yield_to_maturity" type="number" suffix="%" ></a-input>
                                    </div>
                                </div>
                                <div style="width: 5%;flex-shrink: 0;"></div>
                                <div class="table_flex">
                                    <div class="table_div_right">Bid Yield To Maturity：</div>
                                    <div style="width: 100%;">
                                        <a-input :disabled='!bondEditor' :class="{'border_red': obj.falg22}" @blur="blurClick(8)" @input="obj.falg22=false" v-model="form.bid_yield_to_maturity" type="number" suffix="%" ></a-input>
                                    </div>
                                </div>
                            </div>
                            <!-- 13 -->
                            <div class="table_flex table_bottom">
                                <div class="table_flex table_flex_left">
                                    <div class="table_div_left">信貸評級：</div>
                                    <div style="width: 100%;">
                                        <!-- <a-input :disabled='!bondEditor' v-model="form.three_year_annualized_returns_cn"></a-input> -->
                                        <a-select v-model="form.credit_rating" :class="{'border_red': obj.falg15}" @change="obj.falg15=false"  :disabled='!bondEditor'  style="width: 100%;">
                                            <a-select-option v-for="(item,index) in rateList" :key="index" :value="parseInt(item.value)">{{item.text_cn}}</a-select-option>
                                        </a-select>
                                    </div>
                                </div>
                                <div style="width: 5%;flex-shrink: 0;"></div>
                                <div class="table_flex">
                                    <div class="table_div_right">Credit Rating：</div>
                                    <div style="width: 100%;">
                                        <!-- <a-input :disabled='!bondEditor' v-model="form.three_year_annualized_returns_en"></a-input> -->
                                        <a-select v-model="form.credit_rating" :class="{'border_red': obj.falg15}" @change="obj.falg15=false" :disabled='!bondEditor'  style="width: 100%;">
                                            <a-select-option v-for="(item,index) in rateList" :key="index" :value="parseInt(item.value)">{{item.text_en}}</a-select-option>
                                        </a-select>
                                    </div>
                                </div>
                            </div>
                            <!-- 14 -->
                            <div class="table_flex table_bottom">
                                <div class="table_flex table_flex_left">
                                    <div class="table_div_left">專業投資者：</div>
                                    <div style="width: 100%;">
                                        <a-select v-model="form.professional_investor" :class="{'border_red': obj.falg14}" @change="obj.falg14=false" :disabled='!bondEditor'  style="width: 100%;">
                                            <a-select-option :value="2">是</a-select-option>
                                            <a-select-option :value="1">否</a-select-option>
                                        </a-select>
                                    </div>
                                </div>
                                <div style="width: 5%;flex-shrink: 0;"></div>
                                <div class="table_flex">
                                    <div class="table_div_right">Professional Investor：</div>
                                    <div style="width: 100%;">
                                        <a-select v-model="form.professional_investor" :class="{'border_red': obj.falg14}" @change="obj.falg14=false"  :disabled='!bondEditor'  style="width: 100%;">
                                            <a-select-option :value="2">YES</a-select-option>
                                            <a-select-option :value="1">NO</a-select-option>
                                        </a-select>
                                    </div>
                                </div>
                            </div>
                            <!-- 15 -->
                            <div class="table_flex table_bottom">
                                <div class="table_flex table_flex_left">
                                    <div class="table_div_left">複雜投資產品：</div>
                                    <div style="width: 100%;">
                                        <a-select v-model="form.complex_product" :class="{'border_red': obj.falg13}" @change="obj.falg13=false" :disabled='!bondEditor'  style="width: 100%;">
                                            <a-select-option :value="2">是</a-select-option>
                                            <a-select-option :value="1">否</a-select-option>
                                        </a-select>
                                    </div>
                                </div>
                                <div style="width: 5%;flex-shrink: 0;"></div>
                                <div class="table_flex">
                                    <div class="table_div_right">Complex Product：</div>
                                    <div style="width: 100%;">
                                        <a-select v-model="form.complex_product" :class="{'border_red': obj.falg13}" @change="obj.falg13=false" :disabled='!bondEditor'  style="width: 100%;">
                                            <a-select-option :value="2">YES</a-select-option>
                                            <a-select-option :value="1">NO</a-select-option>
                                        </a-select>
                                    </div>
                                </div>
                            </div>
                            <!-- 16 -->
                            <div class="table_flex table_bottom">
                                <div class="table_flex table_flex_left">
                                    <div class="table_div_left">發行日期：</div>
                                    <div style="width: 100%;">
                                        <a-date-picker @change="formatDate(form.issue_date,1),obj.falg17=false" :class="{'border_red': obj.falg17}" v-model="form.issue_date" placeholder=" " :disabled='!bondEditor'/>
                                        <!-- <a-input :disabled='!bondEditor' v-model="form.returns_2020_cn"></a-input> -->
                                    </div>
                                </div>
                                <div style="width: 5%;flex-shrink: 0;"></div>
                                <div class="table_flex">
                                    <div class="table_div_right">Issue Date：</div>
                                    <div style="width: 100%;">
                                        <a-date-picker @change="formatDate(form.issue_date,1),obj.falg17=false" :class="{'border_red': obj.falg17}" v-model="form.issue_date" placeholder=" " :disabled='!bondEditor' />
                                        <!-- <a-input :disabled='!bondEditor' v-model="form.returns_2020_en"></a-input> -->
                                    </div>
                                </div>
                            </div>
                          
                            <!-- 17 -->
                            <div class="table_flex table_bottom">
                                <div class="table_flex table_flex_left">
                                    <div class="table_div_left">發債機構：</div>
                                    <div style="width: 100%;">
                                        <Situationall v-model="form.bond_lssuing_institution_cn"
                                            @child='handclose'
                                            :classFlag="obj.falg4"
                                            :disabled="!bondEditor"
                                            :url='$api.getBondIssuingInstitution'
                                            :params='{"lan":"big5"}'
                                            :valstr='form.bond_lssuing_institution_cn1'
                                            :style='"width: 100%;"'>
                                        </Situationall>
                                        <!-- <a-input :disabled='!bondEditor' :class="{'border_red': obj.falg4}" @input="obj.falg4=false" v-model="form.bond_lssuing_institution_cn"></a-input> -->
                                    </div>
                                </div>
                                <div style="width: 5%;flex-shrink: 0;"></div>
                                <div class="table_flex">
                                    <div class="table_div_right">Issuing Institution：</div>
                                    <div style="width: 100%;">
                                        <Situationall2 v-model="form.bond_lssuing_institution_en"
                                            @child='handclose2'
                                            :classFlag="obj.falg5"
                                            :disabled="!bondEditor"
                                            :url='$api.getBondIssuingInstitution'
                                            :params='{"lan":"eng"}'
                                            :valstr='form.bond_lssuing_institution_en1'
                                            :style='"width: 100%;"'>
                                        </Situationall2>
                                        <!-- <a-input :disabled='!bondEditor' :class="{'border_red': obj.falg5}" @input="obj.falg5=false" v-model="form.bond_lssuing_institution_en"></a-input> -->
                                    </div>
                                </div>
                            </div>
                            <!-- 18 -->
                            <div class="table_flex table_bottom">
                                <div class="table_flex table_flex_left">
                                    <div class="table_div_left">可否贖回：</div>
                                    <div style="width: 100%;">
                                        <a-select v-model="form.redeemable" :class="{'border_red': obj.falg23}" @change="obj.falg23=false" :disabled='!bondEditor'  style="width: 100%;">
                                            <a-select-option :value="2">是</a-select-option>
                                            <a-select-option :value="1">否</a-select-option>
                                        </a-select>
                                    </div>
                                </div>
                                <div style="width: 5%;flex-shrink: 0;"></div>
                                <div class="table_flex">
                                    <div class="table_div_right">Redeemable：</div>
                                    <div style="width: 100%;">
                                        <a-select v-model="form.redeemable" :class="{'border_red': obj.falg23}" @change="obj.falg23=false"  :disabled='!bondEditor'  style="width: 100%;">
                                            <a-select-option :value="2">YES</a-select-option>
                                            <a-select-option :value="1">NO</a-select-option>
                                        </a-select>
                                    </div>
                                </div>
                            </div>
                            <!-- 19 -->
                            <div class="table_flex table_bottom">
                                <div class="table_flex table_flex_left">
                                    <div class="table_div_left">估值日期：</div>
                                    <div style="width: 100%;">
                                        <a-date-picker  @change="formatDate(form.valuation_date,3),obj.falg24=false" :class="{'border_red': obj.falg24}" v-model="form.valuation_date" placeholder=" " :disabled='!bondEditor' />
                                    </div>
                                </div>
                                <div style="width: 5%;flex-shrink: 0;"></div>
                                <div class="table_flex">
                                    <div class="table_div_right">Valuation Date：</div>
                                    <div style="width: 100%;">
                                        <a-date-picker  @change="formatDate(form.valuation_date,3),obj.falg24=false" :class="{'border_red': obj.falg24}" v-model="form.valuation_date" placeholder=" " :disabled='!bondEditor' />
                                    </div>
                                </div>
                            </div>
                            <!-- 20 -->
                            <div class="table_flex table_bottom">
                                <div class="table_flex table_flex_left">
                                    <div class="table_div_left">票面值：</div>
                                    <div style="width: 100%;">
                                        <a-input :disabled='!bondEditor' :class="{'border_red': obj.falg8}"  @input="obj.falg8=false" @blur="blurClick(1)" @focus="focusClick(1)" @change="moneyClick(1)" v-model="form.nominal_value"></a-input>
                                    </div>
                                </div>
                                <div style="width: 5%;flex-shrink: 0;"></div>
                                <div class="table_flex">
                                    <div class="table_div_right">Nominal Value：</div>
                                    <div style="width: 100%;">
                                        <a-input :disabled='!bondEditor' :class="{'border_red': obj.falg8}"  @input="obj.falg8=false" @blur="blurClick(1)" @focus="focusClick(1)" @change="moneyClick(1)"  v-model="form.nominal_value"></a-input>
                                    </div>
                                </div>
                            </div>

                            <!-- 21 -->
                            <div class="table_flex table_bottom">
                                <div class="table_flex table_flex_left">
                                    <div class="table_div_left">風險類型：</div>
                                    <div style="width: 100%;">
                                        <a-select :disabled='!bondEditor' :class="{'border_red': obj.falg7}" @change="obj.falg7=false"  v-model="form.risk_type"  style="width: 100%;">
                                            <a-select-option v-for="(item,index) in riskList" :key="index" :value="parseInt(item.value)">{{item.text_cn}}</a-select-option>
                                        </a-select>
                                        <!-- <a-input :disabled='!bondEditor' v-model="form.risk_type_cn"></a-input> -->
                                    </div>
                                </div>
                                <div style="width: 5%;flex-shrink: 0;"></div>
                                <div class="table_flex">
                                    <div class="table_div_right">Risk Rating：</div>
                                    <div style="width: 100%;">
                                        <a-select :disabled='!bondEditor' :class="{'border_red': obj.falg7}" @change="obj.falg7=false" v-model="form.risk_type"  style="width: 100%;">
                                            <a-select-option v-for="(item,index) in riskList" :key="index" :value="parseInt(item.value)">{{item.text_en}}</a-select-option>
                                        </a-select>
                                        <!-- <a-input :disabled='!bondEditor' v-model="form.risk_type_en"></a-input> -->
                                    </div>
                                </div>
                            </div>
                            <!-- 22 -->
                            <div class="table_flex table_bottom">
                                <div class="table_flex table_flex_left">
                                    <div class="table_div_left">債券簡報：</div>
                                    <div style="width: 100%;">
                                        <a-input :disabled='!bondEditor'  v-model="form.bond_factsheet"></a-input>
                                    </div>
                                </div>
                                <div style="width: 5%;flex-shrink: 0;"></div>
                                <div class="table_flex">
                                    <div class="table_div_right">Bond Factsheet：</div>
                                    <div style="width: 100%;">
                                        <a-input :disabled='!bondEditor'  v-model="form.bond_factsheet_en"></a-input>
                                    </div>
                                </div>
                            </div>



                            <!-- 9 -->
                            <!-- <div class="table_flex table_bottom">
                                <div class="table_flex table_flex_left">
                                    <div class="table_div_left">參考價格：</div>
                                    <div style="width: 100%;">
                                        <a-input :disabled='!bondEditor' :class="{'border_red': obj.falg11}"  @input="obj.falg11=false" @blur="blurClick(2)" @focus="focusClick(2)" @change="moneyClick(2)"  v-model="form.reference_price"></a-input>
                                    </div>
                                </div>
                                <div style="width: 5%;flex-shrink: 0;"></div>
                                <div class="table_flex">
                                    <div class="table_div_right">Reference Price：</div>
                                    <div style="width: 100%;">
                                        <a-input :disabled='!bondEditor' :class="{'border_red': obj.falg11}"  @input="obj.falg11=false" @blur="blurClick(2)" @focus="focusClick(2)" @change="moneyClick(2)"  v-model="form.reference_price"></a-input>
                                    </div>
                                </div>
                            </div>
       -->


         

    

                  

                            <!-- 11111111111111111 -->
                          
                        
             
 


                        </div>
                    </div>
                    <div class='warp_daochu' v-if="fundFlag == 2 && bondReview">
                        <div style="padding-left: .5rem;width:34.5rem">
                            <a-textarea v-model='remark' placeholder=" " allow-clear style='width: 100%;' />
                        </div>
                        <div style="padding: .35rem 0;" >
                            <button class='btn1' @click='shTgEvent(2)' style="background-color: #ed4849;">審核拒絕</button>
                            <button class='btn1 btnx' @click='shTgEvent(1)'>審核通過</button>
                        </div>
                    </div>
                    <div class='warp_daochu' v-else>
                        <div style="padding: .35rem 0;margin-left: auto;">
                            <button class='btn1 btnx'  @click='handokfn(1)'>保存</button>
                            <button class='btn1 ' style="background-color: #f48d28;" @click='handokfn(2)'>提交</button>
                        </div>
                    </div>
                </div>
			</div>
		</a-modal>
	</div>

</template>

<script>
	import https from '@/plugins/http.js';
	import apiUrl from '@/assets/api.js';
	import App from '@/assets/app.js';
    import moment from 'moment';
	export default {
		props: ['fundFlag','param'],
		data() {
			return {
                obj:{
                    falg1:false,
                    falg2:false,
                    falg3:false,
                    falg4:false,
                    falg5:false,
                    falg6:false,
                    falg7:false,
                    falg8:false,
                    falg9:false,
                    falg10:false,
                    falg11:false,
                    falg12:false,
                    falg13:false,
                    falg14:false,
                    falg15:false,
                    falg16:false,
                    falg17:false,
                    falg18:false,
                    falg19:false,
                    falg20:false,
                    falg21:false,
                    falg22:false,
                    falg23:false,
                    falg24:false,
                },
                form:{
                    bond_name_cn:'',  
                    bond_name_en:'',        
                    bond_code:'',        
                    bond_lssuing_institution_cn:'',         
                    bond_lssuing_institution_en:'',         
                    bond_lssuing_institution_cn1:'',         
                    bond_lssuing_institution_en1:'',         
                    bond_type:'',         
                    risk_type:'',         
                    nominal_value:'',           
                    coupon_rate:'',    
                    currency:'',        
                    reference_price:'',
                    minimum_amount:'',   
                    complex_product:'',		
                    professional_investor:'',	
                    credit_rating:'',  
                    coupon_frequency:'',          
                    issue_date:'',   
                    maturity_date:'',       
                    bond_factsheet:'',       
                    bond_factsheet_en:'',      
                    indicative_ask_price:'',       
                    indicative_bid_price:'',       
                    ask_yield_to_maturity:'',       
                    bid_yield_to_maturity:'',       
                    redeemable:'',       
                    valuation_date:'',       
                },
                bondList:[
                    {
                        text_cn:'主權債券',
                        text_en:'Sovereign Bond',
                        value:'1'
                    },
                    {
                        text_cn:'企業債券',
                        text_en:'Corporate Bond',
                        value:'2'
                    },
                    {
                        text_cn:'準主權債券',
                        text_en:'Quasi Sovereign Bond',
                        value:'3'
                    },
                    {
                        text_cn:'資產擔保證券',
                        text_en:'Asset-Backed Security',
                        value:'4'
                    },
                    {
                        text_cn:'高收益企業債券',
                        text_en:'High Yield Bond',
                        value:'5'
                    },
                ],
                riskList:[
                    {
                        text_cn:'最低風險',
                        text_en:'Very Low',
                        value:'1'
                    },
                    {
                        text_cn:'較低風險',
                        text_en:'Comparatively Low',
                        value:'2'
                    },
                    {
                        text_cn:'中等風險',
                        text_en:'Medium',
                        value:'3'
                    },
                    {
                        text_cn:'較高風險',
                        text_en:'Comparatively High',
                        value:'4'
                    },
                    {
                        text_cn:'最高風險',
                        text_en:'Very High',
                        value:'5'
                    },
                ],
                rateList:[
                    {
                        text_cn:'AAA',
                        text_en:'AAA',
                        value:'1'
                    },
                    {
                        text_cn:'AA+',
                        text_en:'AA+',
                        value:'2'
                    },
                    {
                        text_cn:'AA',
                        text_en:'AA',
                        value:'3'
                    },
                    {
                        text_cn:'AA-',
                        text_en:'AA-',
                        value:'4'
                    },
                    {
                        text_cn:'A+',
                        text_en:'A+',
                        value:'5'
                    },
                    {
                        text_cn:'A',
                        text_en:'A',
                        value:'6'
                    },
                    {
                        text_cn:'A-',
                        text_en:'A-',
                        value:'7'
                    },
                    {
                        text_cn:'BBB+',
                        text_en:'BBB+',
                        value:'8'
                    },
                    {
                        text_cn:'BBB',
                        text_en:'BBB',
                        value:'9'
                    },
                    {
                        text_cn:'BBB-',
                        text_en:'BBB-',
                        value:'10'
                    },
                    {
                        text_cn:'BB+',
                        text_en:'BB+',
                        value:'11'
                    },
                    {
                        text_cn:'BB',
                        text_en:'BB',
                        value:'12'
                    },
                    {
                        text_cn:'BB-',
                        text_en:'BB-',
                        value:'13'
                    },
                    {
                        text_cn:'B+',
                        text_en:'B+',
                        value:'14'
                    },
                    {
                        text_cn:'B',
                        text_en:'B',
                        value:'15'
                    },
                    {
                        text_cn:'B-',
                        text_en:'B-',
                        value:'16'
                    },
                    {
                        text_cn:'CCC+',
                        text_en:'CCC+',
                        value:'17'
                    },
                    {
                        text_cn:'CCC',
                        text_en:'CCC',
                        value:'18'
                    },
                    {
                        text_cn:'CCC-',
                        text_en:'CCC-',
                        value:'19'
                    },
                    {
                        text_cn:'CC',
                        text_en:'CC',
                        value:'20'
                    },
                    {
                        text_cn:'C',
                        text_en:'C',
                        value:'21'
                    },
                    {
                        text_cn:'尚未評級',
                        text_en:'Unrated',
                        value:'22'
                    },
                ],
                currencyList:[
                    {
                        text_cn:'港幣',
                        text_en:'HKD',
                        value:'1'
                    },
                    {
                        text_cn:'美元',
                        text_en:'USD',
                        value:'2'
                    },
                    {
                        text_cn:'人民幣',
                        text_en:'CNY',
                        value:'3'
                    },
                    {
                        text_cn:'日元',
                        text_en:'JPY',
                        value:'4'
                    },
                    {
                        text_cn:'澳元',
                        text_en:'AUD',
                        value:'5'
                    },
                    {
                        text_cn:'新加坡元',
                        text_en:'SGD',
                        value:'6'
                    },
                    {
                        text_cn:'台幣',
                        text_en:'TWD',
                        value:'7'
                    },
                    {
                        text_cn:'馬幣',
                        text_en:'MYR',
                        value:'8'
                    },
                ],
                factionalList:[
                    {
                        text_cn:'每月',
                        text_en:'Monthly',
                        value:'1'
                    },
                    {
                        text_cn:'每季',
                        text_en:'Quarterly',
                        value:'2'
                    },
                    {
                        text_cn:'半年度',
                        text_en:'Semi-Annually',
                        value:'3'
                    },
                    {
                        text_cn:'年度',
                        text_en:'Annually',
                        value:'4'
                    },
                    {
                        text_cn:'非固定',
                        text_en:'Incidental',
                        value:'5'
                    },
                ],
                remark:'',
                visible:true,
                bjFlag : false,
                //: "編輯管理員": "bondEditor"有新增 编辑权限     审批管理员 bondReview 审批权限
				bondEditor: this.$store.state.rolesdata.indexOf('bondEditor') >= 0,
				bondReview: this.$store.state.rolesdata.indexOf('bondReview') >= 0,
			}
		},
		mounted() {
            this.getdata()
		},
		methods: {
            handclose(a,b){
                    this.obj.falg4 = b
            },
            handclose2(a,b){
                    this.obj.falg5 = b
            },
            disabledDate(current) {
                return current && current < moment().endOf('day');
            },
            focusClick(val){
                if (val == 1) {
                    if (this.form.nominal_value) {
                        this.form.nominal_value = this.form.nominal_value.replace(/,/g, '');
                    }
                }
                if (val == 2) {
                    if (this.form.reference_price) {
                        this.form.reference_price = this.form.reference_price.replace(/,/g, '');
                    }
                }
                if (val == 3) {
                    if (this.form.minimum_amount) {
                        this.form.minimum_amount = this.form.minimum_amount.replace(/,/g, '');
                    }
                }
                if (val == 5) {
                    if (this.form.indicative_ask_price) {
                        this.form.indicative_ask_price = this.form.indicative_ask_price.replace(/,/g, '');
                    }
                }
                if (val == 6) {
                    if (this.form.indicative_bid_price) {
                        this.form.indicative_bid_price = this.form.indicative_bid_price.replace(/,/g, '');
                    }
                }
                if (val == 9) {
                    if (this.form.initial_amount) {
                        this.form.initial_amount = this.form.initial_amount.replace(/,/g, '');
                    }
                }
            },
            moneyClick(val){
                if (val == 1) {
                    if (this.form.nominal_value) {
                        this.form.nominal_value = this.form.nominal_value.match(/\d+\.?\d{0,3}/,'')
                    }
                }
                if (val == 2) {
                    if (this.form.reference_price) {
                        this.form.reference_price = this.form.reference_price.match(/\d+\.?\d{0,2}/,'')
                    }
                }
                if (val == 3) {
                    if (this.form.minimum_amount) {
                        this.form.minimum_amount = this.form.minimum_amount.match(/\d+\.?\d{0,2}/,'')
                    }
                }
                if (val == 5) {
                    if (this.form.indicative_ask_price) {
                        this.form.indicative_ask_price = this.form.indicative_ask_price.match(/\d+\.?\d{0,3}/,'')
                    }
                }
                if (val == 6) {
                    if (this.form.indicative_bid_price) {
                        this.form.indicative_bid_price = this.form.indicative_bid_price.match(/\d+\.?\d{0,3}/,'')
                    }
                }
                if (val == 9) {
                    if (this.form.initial_amount) {
                        this.form.initial_amount = this.form.initial_amount.match(/\d+\.?\d{0,2}/,'')
                    }
                }
            },
            blurClick(val){
                if (val == 1) {
                    this.form.nominal_value =  this.getArea(Number(this.form.nominal_value).toFixed(3))
                }
                if (val == 2) {
                    this.form.reference_price =  this.getArea(Number(this.form.reference_price).toFixed(2))
                }
                if (val == 3) {
                    this.form.minimum_amount =  this.getArea(Number(this.form.minimum_amount).toFixed(2))
                }
                if (val == 4) {
                    this.form.coupon_rate =  Number(this.form.coupon_rate).toFixed(3)
                }
                if (val == 5) {
                    this.form.indicative_ask_price =  this.getArea(Number(this.form.indicative_ask_price).toFixed(3))
                }
                if (val == 6) {
                    this.form.indicative_bid_price =  this.getArea(Number(this.form.indicative_bid_price).toFixed(3))
                }
                if (val == 7) {
                    this.form.ask_yield_to_maturity =  Number(this.form.ask_yield_to_maturity).toFixed(3)
                }
                if (val == 8) {
                    this.form.bid_yield_to_maturity =  Number(this.form.bid_yield_to_maturity).toFixed(3)
                }
                if (val == 9) {
                    this.form.initial_amount =  this.getArea(Number(this.form.initial_amount).toFixed(2))
                }
            },
            getArea(area) {
                return String(area).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
            },
            handleInput(val){
                this.form.bond_name_en = this.form.bond_name_en.replace(/[\u4e00-\u9fa5]/g, '');
            },
            formatDate(valTime,index) {
                const date = new Date(valTime);
                let year = date.getFullYear();
                let month = date.getMonth() + 1; // 月份是从 0 开始的，所以需要加1
                let day = date.getDate();
                let formattedDate = year + '-' + (month < 10 ? '0' : '') + month + '-' + (day < 10 ? '0' : '') + day;
                console.log(formattedDate);
                if (index == 1) {
                    this.form.issue_date = formattedDate;
                }
                if (index == 2) {
                    this.form.maturity_date = formattedDate;
                }
                if (index == 3) {
                    this.form.valuation_date = formattedDate;
                }
            },
            getdata(){
                if (this.fundFlag == 1) {
                    return
                }
                this.$ajax({
                    method: 'post',
                    url: this.$api.getBondById,
                    data: {
                        type:this.param.type,
                        id:this.param.id,
                }
                }).then(res => {
                    if (res.data.qmiscode === 1000) {
                        this.form = res.data;
                        this.form.bond_lssuing_institution_cn1 = JSON.parse(JSON.stringify(this.form.bond_lssuing_institution_cn))
                        this.form.bond_lssuing_institution_en1 = JSON.parse(JSON.stringify(this.form.bond_lssuing_institution_en))
                        const parts = res.data.issue_date.split("/");
                        const newDate = parts[2] + "-" + parts[1] + "-" + parts[0];
                        const parts1 = res.data.maturity_date.split("/");
                        const newDate1 = parts1[2] + "-" + parts1[1] + "-" + parts1[0];
                        this.form.issue_date = newDate
                        this.form.maturity_date = newDate1
                    } else {
                        this.$message.warning(res.data.qmismsg)
                    }
                })
            },
            shTgEvent(val){
                if (val == 2 && !this.remark) {
                    this.$message.warning('請填寫備註信息')
                    return
                }else{
                    if (!this.remark) {
                        this.remark = '資料齊全'
                    }
                }
                this.form.remark = this.remark
                this.form.is_pass = val
                this.$ajax({
                    method: 'post',
                    url: this.$api.bondSubscriptionExamine,
                    data:this.form
                    // data: {
                    //     approval_person:this.param.approval_person,
                    //     approval_person_id:this.param.approval_person_id,
                    //     review_nodes:this.param.review_nodes,
                    //     type:this.param.type,
                    //     id:this.param.id,
                    //     remark:this.remark
                    // }
                }).then(res => {
                    if (res.data.qmiscode === 1000) {
                        this.$emit('child')
                    } else {
                        this.$message.warning(res.data.qmismsg)
                    }
                })
            },
            resetting(){
                this.form={
                    bond_name_cn:'',  
                    bond_name_en:'',        
                    bond_code:'',        
                    bond_lssuing_institution_cn:'',         
                    bond_lssuing_institution_en:'',         
                    bond_lssuing_institution_cn1:'',         
                    bond_lssuing_institution_en1:'',         
                    bond_type:'',         
                    risk_type:'',         
                    nominal_value:'',           
                    coupon_rate:'',    
                    currency:'',        
                    reference_price:'',
                    minimum_amount:'',   
                    complex_product:'',		
                    professional_investor:'',	
                    credit_rating:'',  
                    coupon_frequency:'',          
                    issue_date:'',   
                    maturity_date:'',       
                    bond_factsheet:'',       
                    bond_factsheet_en:'', 
                }
            },
			handokfn(val){
                /**
                 * val : 1=保存，2=提交
                 */
                if (!this.form.bond_name_cn) {
                    this.obj.falg1 = true
                    return
                }
                if (!this.form.bond_name_en) {
                    this.obj.falg2 = true
                    return
                }
                if (!this.form.bond_code) {
                    this.obj.falg3 = true
                    return
                }
                if (!this.form.bond_lssuing_institution_cn) {
                    this.obj.falg4 = true
                    return
                }
                if (!this.form.bond_lssuing_institution_en) {
                    this.obj.falg5 = true
                    return
                }
                if (!this.form.bond_type) {
                    this.obj.falg6 = true
                    return
                }
                if (!this.form.risk_type) {
                    this.obj.falg7 = true
                    return
                }
                if (!this.form.nominal_value) {
                    this.obj.falg8 = true
                    return
                }
                if (!this.form.coupon_rate) {
                    this.obj.falg9 = true
                    return
                }
                if (!this.form.currency) {
                    this.obj.falg10 = true
                    return
                }
                // if (!this.form.reference_price) {
                //     this.obj.falg11 = true
                //     return
                // }
                if (!this.form.minimum_amount) {
                    this.obj.falg12 = true
                    return
                }
                if (!this.form.complex_product) {
                    this.obj.falg13 = true
                    return
                }
                if (!this.form.professional_investor) {
                    this.obj.falg14 = true
                    return
                }
                if (!this.form.credit_rating) {
                    this.obj.falg15 = true
                    return
                }
                if (!this.form.coupon_frequency) {
                    this.obj.falg16 = true
                    return
                }
                if (!this.form.issue_date) {
                    this.obj.falg17 = true
                    return
                }
                if (!this.form.maturity_date) {
                    this.obj.falg18 = true
                    return
                }
                if (!this.form.indicative_ask_price) {
                    this.obj.falg19 = true
                    return
                }
                if (!this.form.indicative_bid_price) {
                    this.obj.falg20 = true
                    return
                }
                if (!this.form.ask_yield_to_maturity) {
                    this.obj.falg21 = true
                    return
                }
                if (!this.form.bid_yield_to_maturity) {
                    this.obj.falg22 = true
                    return
                }
                if (!this.form.redeemable) {
                    this.obj.falg23 = true
                    return
                }
                if (!this.form.valuation_date) {
                    this.obj.falg24 = true
                    return
                }
                // if (!this.form.initial_amount) {
                //     this.obj.falg25 = true
                //     return
                // }

                this.form.token = this.$store.state.token
                let url
                if (val == 1) {
                    url = this.$api.saveBondSubscription
                }else{
                    url = this.$api.submitBondSubscription
                }
                this.$ajax({
                    method: 'post',
                    url: url,
                    headers: {
                        token: this.$store.state.token,
                    },
                    data: this.form
                }).then(res => {
                    console.log(res.data)
                    if (res.data.qmiscode == 1000) {
                        App.oTool.successT(res.data.qmismsg);
                        this.$emit('child')
                    } else {
                        App.oTool.warningT(res.data.error);
                    }
                })
			},
			savefn() {
                this.$emit('child', 0)
                this.resetting()
			},
            handleOk(){
			},
            handleCancel(){
				this.$emit('child', 0)
                this.resetting()
			},

		}
	}
</script>
<style>
    input[type=number]::-webkit-inner-spin-button, 
    input[type=number]::-webkit-outer-spin-button { 
        -webkit-appearance: none; 
        margin: 0; 
    }
    .border_red{
        border-color: red !important;
    }
    .border_red .ant-select-selection{
        border-color: red !important;
    }
    .border_red .ant-calendar-picker-input{
        border-color: red !important;
    }
    .border_red .ant-input{
        border-color: red !important;
    }
</style>
<style scoped>
    .table_flex_left{
        width: 85% !important;
    }
    .table_flex{
        display: flex;
        align-items: center;
        width: 100%;
        font-size: 0.8rem;
    }
    .table_bottom{
        margin-bottom: 0.7rem;
    }
    .table_div_left{
        flex-shrink: 0;
        width: 6.5rem;
    }
    .table_div_right{
        flex-shrink: 0;
        width: 9.9rem;
    }
	#handitemedit1 .tabelMoreFzView .tabelMoreFzViewIn {
		background-color: #fff;
		padding: 0.7rem 0;
		border-radius: 4px;
		overflow: hidden;
	}

	#handitemedit1 .tabelMoreFzView .tabelMoreFzViewIn .tabelMoreFzViewInList {
		padding: 0.5rem 0;
		border-bottom: 1px #f3f3f3 solid;
		display: flex;
		align-items: flex-start;
	}

	#handitemedit1 .tabelMoreFzView .tabelMoreFzViewIn .tabelMoreFzViewInList:last-child {
		border: none;
	}

	#handitemedit1 .tabelMoreFzView .tabelMoreFzViewIn .tabelMoreFzViewInList .left {
		width: 24%;
		color: #000;
		font-size: 0.8rem;
	}

	#handitemedit1 .center {
		/* height: 1.7rem;
		    line-height: 1.7rem; */
	}

	#handitemedit1 .tabelMoreFzView .tabelMoreFzViewIn .tabelMoreFzViewInList .center {
		font-size: 0.8rem;
		width: calc(70% - 2rem);
		color: #000;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}

	#handitemedit1 .tabelMoreFzView .tabelMoreFzViewIn .tabelMoreFzViewInList img {
		width: 1.2rem;
		height: 1.2rem;
		margin: auto 0;
		margin-left: auto;
	}
</style>
<style lang="scss">
#main-handhomes{
		.ant-select-selection{
			color: #000;
			background-color: #fff;
		}
		 .ant-input-disabled {
		    color: #000;
		    background-color: #fff;
		}
		.has-error .ant-form-explain, .has-error .ant-form-split{
			display: none;
		}
		.ant-form-inline .ant-form-item-with-help {
		    margin-bottom: 0;
		}
		.ant-form label{
			font-size: .8rem;
		}
		.ant-modal-header, .ant-modal-body{
			border-radius:0 !important;
		}
		
		 .ant-modal-header, .ant-modal-body{
			background-color: #e5e5e5 !important;
			padding: 1rem;
			padding-top: .7rem;
		}
		
		.main-hand-title{
			position: absolute;
			top: 0;
			left: 0;
			div{
				font-size: 1rem;
				padding: .8rem 1rem .2rem 1rem;
				background-color:  #e5e5e5;
			}
		}
		
		.wland{
			display: inline-block;
			width: 7rem;
			padding: .4rem 0 .6rem;
			text-align: center;
			background-color: #fff;
			color: #000;
			border-top: .2rem solid #e99c00;
			border-right: 1px solid #e5e5e5;
			font-size: .8rem;
		}
		
		.gland{
			display: inline-block;
			width: 7rem;
			padding: .6rem 0;
			text-align: center;
			background-color: #0c8b97;
			color: #fff;
			font-size: .8rem;
			border-right: 1px solid #e5e5e5;
		}
	}
	
	#tubody-mainsk1>div{
		padding: 1px 0;
	}
	
	#tubody-mainsk1{
		background-color: #fff;
		.main-mybody{
			padding: .5rem 1.5rem 0;
			overflow-y: auto;
			min-height: 12rem;
			max-height: 30rem;
		}
		
		.ant-empty-normal{
				margin: 7rem 0;
		}
		
		.main-wid{
			width: 85%;
			height: 1px;
			border-top: .5px solid #d8d8d8;
			margin: 1rem 0;
		}
		
		.ant-col {
			font-size: .8rem;
			color: #000;
			margin: .2rem 0;
		}
		
		.btn{
			cursor: pointer;
			width: 6rem;
			height: 2rem;
			font-size: 0.8rem;
			color: #fff;
			border: 0;
			border-radius: 5px;
			text-align: center;
			line-height: 2rem;
			background-color: #0c8b97;
			margin: 1rem;
		}
		.btn1 {
			cursor: pointer;
			width: 5rem;
			height: 2rem;
			font-size: .8rem;
			color: #fff;
			border: 0;
			/* border-radius: 5px; */
			margin: 0 1rem;
		}
		.btnx {
			background-color: #0c8b97;
		}
		
		.btn2 {
			background-color: #f48d28;
		}
		
		.warp_daochu{
			border-top: 1px solid rgb(232, 232, 232);
			display: flex;
			justify-content: space-between;
			padding: 1rem .5rem ;
		
			div{
				font-size: .7rem;
			}
		}
	}
	#on-center {
		.ant-form-item-label {
			margin-top: 1.5rem;
		}
	}

	#handitemedit1 {

		.ant-row,
		.ant-calendar-picker {
			width: 100%;
		}

		.ant-form-item-label {
			width: 15% !important;
		}

		.ant-form-item-control-wrapper {
			width: 70% !important;

			.wart-t {
				width: 100%;
			}
		}

		.ant-calendar-picker-input {
			width: 100%;
		}

		.myright {
			.ant-form-item-label {
				width: 30% !important;
				padding-left: 3.5%;
			}
		}

		.warp_long {
			width: 50%;
			display: inline-block;

			.ant-form-item-label {
				width: 30% !important;
			}

			.ant-form-item-control-wrapper {
				width: 60% !important;

			}
		}

		.texright {
			text-align: right;
			// margin-left: 4%;
		}
	}
</style>
